import { createAction, joinActions } from "../../helpers/store/actions-helpers";

export const sessionClearAction = createAction("[Session] Clear");

const actions = joinActions({
  sessionClearAction,
});

export type SessionAction = typeof actions;
